
import {buriedChannelPoint} from '@/api/common'
import { getCommonClientConfig} from "@a";

export default {
    data() {
        return {
            downloadUrls: {}//下载地址
        };
    },
    mounted() {
        // buriedPoint({code: 'H5PAGE'});
        buriedChannelPoint({code: 'LAWYER_GUIDE_CASE_SHARE_PAGE', type: 2, behavior: 'VI'});
        this.getApk();
    },
    methods: {
        /*判断是否微信*/
        is_weixn() {
            var ua = navigator.userAgent.toLowerCase();
            return ua.match(/MicroMessenger/i) == "micromessenger";
        },
        /*按钮点击唤醒app*/
        openApp() {
            // buriedChannelPoint({code:'LAW_PAGE_GO_TO_APP_PAGE',type: 2, behavior: 'CK'})
            buriedChannelPoint({code: 'LAWYER_GUIDE_CASE_SHARE_GO_APP_CLICK', type: 2, behavior: 'CK'})
            // /*唤醒app*/+window.location.search
            // const {search} = this.$route.query
            const {id} = this.$route.query
            const lawyerId = localStorage.getItem('GOODNEWSLAWYERID')
            if (this.isIOSClient()) {
                // window.location.href = 'Lawyer://?'+search;
                // window.location.href = 'Lawyer://';
                window.location.href = `Lawyer://?detailId=${id}&lawyerId=${lawyerId}&path=share_goodNewsDetail`;
            } else {
                window.location.href = `yoclawyer://yoclawyer/open?detailId=${id}&lawyerId=${lawyerId}&path=share_goodNewsDetail`;
                // window.location.href = `yoclawyer://yoclawyer/open`;
            }
        },
        /*按钮点击下载*/
        buttonDownload() {
            // buriedPoint({code: 'DOWNLOAD',extra:{appType:1}})
            // buriedChannelPoint({code: 'LAW_PAGE_DOWN_APP_PAGE',type: 2, behavior: 'CK'})
            buriedChannelPoint({code: 'LAWYER_GUIDE_CASE_SHARE_DOWNLOAD_CLICK', type: 2, behavior: 'CK'})
            this.getApk().then((value) => {
                if (this.isIOSClient()) {
                    window.location.href = value.downloadGfUrlIos;
                } else {
                    /*先喚醒安卓应用市场*/
                    window.location.href = value.androidGfAppstoreUrl;
                    /*防止安卓没有上架到应用市场*/
                    setTimeout(function () {
                        window.location.href = value.downloadGfUrlApk;
                    }, 500)
                }
            });
        },
        /*判断是否ios*/
        isIOSClient() {
            return this.judgeClient() === 'IOS';
        },
        /*获取操作系统*/
        judgeClient() {
            var u = navigator.userAgent;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //判断是否是 android终端
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 ios终端
            if (isAndroid === true) {
                return 'Android';
            } else if (isIOS === true) {
                return 'IOS';
            } else {
                return 'Android';
            }
        },
        /*获取下载地址*/
        getApk() {
            if (this.$basicsTools.isObjNull(this.downloadUrls)) {
                return getCommonClientConfig().then((value) => {
                    this.downloadUrls = value.data;
                    return this.downloadUrls
                })
            }
            return Promise.resolve(this.downloadUrls)
        },
    },
};
